module.exports = __webpack_public_path__ + "static/media/multiple-images-1.e50f90a6.png";